import { render, staticRenderFns } from "./GarbageDisposalDistricts.vue?vue&type=template&id=6a9b62c6&"
import script from "./GarbageDisposalDistricts.vue?vue&type=script&lang=js&"
export * from "./GarbageDisposalDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports